import { StyleSheet } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: RESIDENTS_DESKTOP_COLORS.SECONDARY_BACKGROUND,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 16,
    paddingBottom: 12,
    paddingHorizontal: 16,
  },
  tabs: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingTop: 16,
    marginBottom: 24,
    gap: 16,
  },
  tabItem: {
    flex: 1,
    backgroundColor: RESIDENTS_DESKTOP_COLORS.PRIMARY_BACKGROUND,
    borderRadius: 16,
    overflow: 'hidden',
    borderBottomWidth: 4,
    borderBottomColor: 'transparent',
    paddingTop: 24,
    paddingBottom: 24,
    paddingHorizontal: 24,
  },
  tabItemActive: {
    backgroundColor: RESIDENTS_DESKTOP_COLORS.CIRCLE_ICON_BACKGROUND,
  },
  tabHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  tabTitleText: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    fontSize: 20,
    fontWeight: '800',
  },
  tabTitleTextActive: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
  },
  subTitleText: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
    fontSize: 13,
    opacity: 0.65,
  },
  countPill: {
    minWidth: 28,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.2)',
    alignItems: 'center',
  },
  countPillHidden: {
    opacity: 0,
  },
  countPillText: {
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    fontWeight: '700',
  },
  activeBorder: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: 4,
    backgroundColor: 'transparent',
  },
  activeBorderAccounts: {
    backgroundColor: RESIDENTS_DESKTOP_COLORS.linkedAccounts.accountsTabsBorder,
  },
  activeBorderInvitations: {
    backgroundColor: RESIDENTS_DESKTOP_COLORS.linkedAccounts.invitationTabsBorder,
  },
  activeBorderHow: {
    backgroundColor: RESIDENTS_DESKTOP_COLORS.linkedAccounts.howTabsBorder,
  },
  headerActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  inviteButton: {
    backgroundColor: '#111827',
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderRadius: 8,
  },
  inviteButtonText: {
    color: '#FFFFFF',
    fontWeight: '600',
    fontSize: 14,
  },
  refreshButton: {
    backgroundColor: '#6b7280',
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 8,
  },
  refreshButtonText: {
    color: '#FFFFFF',
    fontWeight: '600',
    fontSize: 14,
  },
  scroll: {
    flex: 1,
  },
  scrollContent: {
    paddingHorizontal: 16,
    paddingBottom: 24,
  },
  invitationsContainer: {
    flex: 1,
  },
  faqContainer: {
    marginTop: -24,
    flex: 1,
  },
  centerContent: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  list: {
    gap: 16,
  },
  cardWrapper: {
    marginBottom: 16,
  },
});


